import * as constants from '../../constants';

export default function ( width, height, correct, total ) {
  const c = new PIXI.Sprite();
  c.anchor.set(0, 0.5);

  if ( !total ) {
    return c;
  }

  const redBar = new PIXI.Graphics();
  c.addChild(redBar);
  redBar.beginFill(constants.red).drawRect(0, -height/2, width, height).endFill();

  const greenBar = new PIXI.Graphics();
  c.addChild(greenBar);
  const w = width * correct / total;
  greenBar.beginFill(constants.green).drawRect(0, -height/2, w, height).endFill();

  return c;
}
